import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';

function LoginPage({ onSwitchToRegister, onViewTerms, onViewPrivacy }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);

    setLoading(false);

    if (!result.success) {
      setError(result.message);
    }
  };

  return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary to-purple-600 px-4">
        <div className="w-full max-w-md">
          {/* 로고 및 헤더 */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center size-16 rounded-full bg-white dark:bg-white shadow-lg mb-4">
              <span className="material-symbols-outlined text-primary text-4xl">auto_awesome</span>
            </div>
            <h1 className="text-4xl font-black text-white mb-2">InstaAuto</h1>
            <p className="text-white/80 text-lg">K-pop 자동화 관리 시스템</p>
          </div>

          {/* 로그인 폼 */}
          <div className="bg-white dark:bg-[#111118] rounded-2xl shadow-2xl p-8 border border-slate-200 dark:border-[#282839]">
            <h2 className="text-2xl font-bold text-center mb-6 text-slate-900 dark:text-white">
              로그인
            </h2>

            <form onSubmit={handleSubmit} className="space-y-5">
              {/* 아이디 입력 */}
              <div className="space-y-2">
                <label
                    htmlFor="username"
                    className="text-sm font-semibold px-1 text-slate-900 dark:text-white block"
                >
                  아이디
                </label>
                <div className="relative">
                <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500 material-symbols-outlined">
                  person
                </span>
                  <input
                      type="text"
                      id="username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      placeholder="아이디를 입력하세요"
                      required
                      autoFocus
                      className="w-full pl-12 pr-4 h-14 bg-slate-50 dark:bg-[#1c1c27] border border-slate-200 dark:border-[#3b3b54] rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500"
                  />
                </div>
              </div>

              {/* 비밀번호 입력 */}
              <div className="space-y-2">
                <label
                    htmlFor="password"
                    className="text-sm font-semibold px-1 text-slate-900 dark:text-white block"
                >
                  비밀번호
                </label>
                <div className="relative">
                <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500 material-symbols-outlined">
                  lock
                </span>
                  <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="비밀번호를 입력하세요"
                      required
                      className="w-full pl-12 pr-12 h-14 bg-slate-50 dark:bg-[#1c1c27] border border-slate-200 dark:border-[#3b3b54] rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500"
                  />
                  <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300 transition-colors"
                  >
                    <span className="material-symbols-outlined text-xl">
                      {showPassword ? 'visibility' : 'visibility_off'}
                    </span>
                  </button>
                </div>
              </div>

              {/* 에러 메시지 */}
              {error && (
                  <div className="p-4 rounded-xl border bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-700 text-red-800 dark:text-red-200 text-sm">
                    <div className="flex items-center gap-2">
                      <span className="material-symbols-outlined text-base">error</span>
                      <span>{error}</span>
                    </div>
                  </div>
              )}

              {/* 로그인 버튼 */}
              <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-4 bg-primary text-white rounded-xl font-bold text-base shadow-lg shadow-primary/40 hover:opacity-90 active:scale-[0.98] transition-all flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
              >
                {loading ? (
                    <>
                      <span className="material-symbols-outlined animate-spin">progress_activity</span>
                      로그인 중...
                    </>
                ) : (
                    <>
                      <span className="material-symbols-outlined">login</span>
                      로그인
                    </>
                )}
              </button>
            </form>

            {/* 회원가입 링크 */}
            {onSwitchToRegister && (
              <div className="mt-6 pt-4 border-t border-slate-200 dark:border-[#282839] text-center">
                <button
                  onClick={onSwitchToRegister}
                  className="text-sm text-primary hover:underline font-medium"
                >
                  계정이 없으신가요? 회원가입
                </button>
              </div>
            )}

            {/* 하단 정보 */}
            <div className="mt-4 pt-4 border-t border-slate-200 dark:border-[#282839]">
              <div className="flex items-center justify-center gap-2 text-xs text-slate-500 dark:text-slate-400">
                <span className="size-2 bg-green-500 rounded-full animate-pulse"></span>
                <span>시스템 정상 운영 중</span>
              </div>
              <div className="flex items-center justify-center gap-3 mt-3 text-xs text-slate-400 dark:text-slate-500">
                <button type="button" onClick={onViewTerms} className="hover:text-primary hover:underline transition-colors">
                  이용약관
                </button>
                <span>|</span>
                <button type="button" onClick={onViewPrivacy} className="hover:text-primary hover:underline transition-colors">
                  개인정보 처리방침
                </button>
              </div>
            </div>
          </div>

          {/* 저작권 */}
          <div className="text-center mt-6">
            <p className="text-white/60 text-sm">
              © 2024 InstaAuto. All rights reserved.
            </p>
          </div>
        </div>
      </div>
  );
}

export default LoginPage;